export const getErrorStatusCode = (error: Error): number =>
  (error as Error & { response?: { status: number } })?.response?.status ?? 500;
